import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="w-full h-[480px] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/18ca25ea8a69d5eb1e849ccadbb7687f/bf2593c08ddc16671e8a29370b92c825.jpeg"
                alt="Modern furnished private room"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-navy-800 text-white p-6 rounded-lg w-52">
              <p className="font-heading text-3xl font-bold text-gold-400">10+</p>
              <p className="text-sm text-white/70 mt-1 leading-snug">Years providing quality housing across regional &amp; metro Australia</p>
            </div>
          </div>

          {/* Text side */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-0.5 bg-gold-500" />
              <span className="text-gold-500 text-sm font-medium tracking-widest uppercase">About Galaxy Housing</span>
            </div>
            <h2 className="font-heading text-4xl lg:text-5xl font-bold text-navy-800 leading-tight mb-6">
              Your Trusted Home Away From Home
            </h2>
            <p className="text-navy-700/70 text-base leading-relaxed mb-5">
              Galaxy Housing has been providing affordable, medium and long-term furnished accommodation across regional towns and metro cities — including Sydney, Brisbane, and Melbourne — for over a decade. We believe everyone deserves a safe, clean, and comfortable home without the stress of managing bills, maintenance, or move-in logistics.
            </p>
            <p className="text-navy-700/70 text-base leading-relaxed mb-8">
              Our properties span large regional areas and growing communities, as well as major Australian cities. Professionally managed with responsive support — because when something needs attention, we're on it. Every home is carefully maintained, regularly cleaned, and located for maximum convenience.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/about"
                className="flex items-center justify-center gap-2 bg-navy-800 hover:bg-navy-700 text-white font-semibold text-sm px-6 py-3.5 rounded transition-colors cursor-pointer whitespace-nowrap"
              >
                Learn More About Us
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </div>
              </Link>
              <Link
                to="/services"
                className="flex items-center justify-center gap-2 border border-navy-200 hover:border-navy-400 text-navy-700 font-semibold text-sm px-6 py-3.5 rounded transition-colors cursor-pointer whitespace-nowrap"
              >
                Our Services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
